// extracted by mini-css-extract-plugin
module.exports = {"skipToMain":"LandingPage_skipToMain__h20MX","root":"LandingPage_root__S1s4B","rotation":"LandingPage_rotation__J4lpf"};